import { withSpinner } from 'src/common/components/with-spinner/with-spinner';
import XLRLogger from 'src/common/helpers/logger';
import { TransactionActions } from 'src/common/redux/reducers/transaction-reducer';
import { CartStatus } from 'src/items-list/business-logic/service/enumerations/cart-status';
import { store } from '../../common/redux/configure-store';
import { applyCartResponse } from './common/apply-cart-response';
import { itemize } from './service/itemization';
import { callUpdateTransactionStatus } from './service/update-cart-status';

export const updateCartStatus = async (): Promise<void> => {
  // RTI only update transaction status when exit total/tender state, i.e. promotionInstruction
  // We may pass parameter for more SE cart status update

  const transactionId = store.getState().transaction.transactionId;
  if (transactionId) {
    await withSpinner(async () => {
      await itemize(transactionId)
        .then(applyCartResponse)
        .catch(XLRLogger.error);
    });
  }
};

export const updateTransactionStatus = async (status: CartStatus): Promise<void> => {
  const currentStatus = store.getState().transaction.cartStatus;
  if (currentStatus !== status) {
    await callUpdateTransactionStatus(status).catch(XLRLogger.error);
    store.dispatch(TransactionActions.setCartStatus(status));
  }
};
